goog.provide('el8.tourguide.Visor');


el8.tourguide.Visor = function(opts) {
    opts = opts || {};
    this._container = null;
    this._isMinimized = false;
    this._height = opts.height;
    this._contentFn = opts.contentFn;
    this._slideNavContentFn = opts.slideNavContentFn || null;
    this._clickTriggerMap = opts.clickTriggerMap || null;

    this._NEW_SLIDE_CLASS = 'teaserProgressTextNew';
    this._ACTIVE_SLIDE_CLASS = 'teaserProgressTextActive';
    this._DONE_SLIDE_CLASS = 'teaserProgressTextDone';
};

el8.tourguide.Visor.prototype._init = function() {

    if (this._isInit) { return; }
    this._isInit = true;
    this._container = $(this._contentFn());
    this._container.height(this._height);
    $('#page-chart').prepend(this._container);

    var that = this;
    $(this._container[0]).on('click', '.show-detail-trigger', function(e) {
        that.showDetail();
    });
    $(this._container[0]).on('click', '.hide-detail-trigger', function(e) {
        that.hideDetail();
    });
    if (this._clickTriggerMap) {
        for (var t in this._clickTriggerMap) {
            if (this._clickTriggerMap.hasOwnProperty(t)) {
                $(this._container[0]).on('click', t, that._clickTriggerMap[t]);
            }
        }
    }
};

el8.tourguide.Visor.prototype.show = function(hide) {
    if (!this._isInit) { this._init(); }
    if (hide) { this.hideDetail(); }
    else { this.showDetail(); }
};

el8.tourguide.Visor.prototype.hideDetail = function() {
    $('.visor-content-detail', this._container).hide();
};

el8.tourguide.Visor.prototype.showDetail = function() {
    $('.visor-content-detail', this._container).show();
};

el8.tourguide.Visor.prototype.updateDetailContent = function(contentFn) {
    if (!contentFn) { return; }
    $('.visor-text-detail', this._container).html(contentFn());
};

el8.tourguide.Visor.prototype.updateNavContent = function(contentFn) {
    if (!contentFn) { return; }
    $('.visor-text-nav', this._container).html(contentFn());
};

el8.tourguide.Visor.prototype.getContainer = function() {
    return this._container;
};

el8.tourguide.Visor.prototype.addSlideNav = function(slide) {
    if (this._slideNavContentFn) {
        var $html = $(this._slideNavContentFn({
            name: slide.getName(),
            caption: slide.getNavCaption()
        }));
        $('.visor-nav', this._container).append($html);
    }
};

el8.tourguide.Visor.prototype.focusSlide = function(slide) {

    if (slide.getNavCaption()) {

        var that = this;

        $('.visor-nav', this._container).find('a').each(function(index, elt) {
            var name = $(elt).attr('_name');
            if (name === slide.getName()) {
                $(this)
                    .addClass(that._ACTIVE_SLIDE_CLASS)
                    .removeClass(that._DONE_SLIDE_CLASS)
                    .removeClass(that._NEW_SLIDE_CLASS);
            } else {
                if ($(this).hasClass(that._ACTIVE_SLIDE_CLASS)) {
                    $(this)
                        .removeClass(that._ACTIVE_SLIDE_CLASS)
                        .addClass(that._DONE_SLIDE_CLASS)
                        .removeClass(that._NEW_SLIDE_CLASS);
                }
            }
        });
    }
};

el8.tourguide.Visor.prototype.clearFocus = function() {
    $('.visor-nav', this._container).find('a.'+this._ACTIVE_SLIDE_CLASS)
        .removeClass(this._ACTIVE_SLIDE_CLASS)
        .addClass(this._DONE_SLIDE_CLASS)
        .removeClass(this._NEW_SLIDE_CLASS);
};

el8.tourguide.Visor.prototype.initFocus = function() {
    $('.visor-nav', this._container).find('a')
        .removeClass(this._ACTIVE_SLIDE_CLASS)
        .removeClass(this._DONE_SLIDE_CLASS)
        .addClass(this._NEW_SLIDE_CLASS);
};
